var exports = {
  "kL": "xfd349460--b5c86f--container",
  "HU": "xfd349460--b5c86f--aside",
  "VN": "xfd349460--b5c86f--close",
};

module.exports = exports;
